var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-navbar" },
    [
      _c("div", { staticClass: "user-container-div" }, [
        _c(
          "div",
          {
            staticClass: "minimize-button",
            class: { closed: !_vm.sidebarIsOpen }
          },
          [
            _c(
              "v-btn",
              { attrs: { icon: "" }, on: { click: _vm.toggleSidebar } },
              [
                !_vm.sidebarIsOpen
                  ? _c("v-icon", { attrs: { color: "#767676" } }, [
                      _vm._v("mdi-menu ")
                    ])
                  : _c("v-icon", { attrs: { color: "#767676" } }, [
                      _vm._v("mdi-menu-open ")
                    ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-name", class: { closed: !_vm.sidebarIsOpen } },
          [_vm._v("\n      " + _vm._s(_vm.pageName) + "\n    ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "on-clickaway",
              rawName: "v-on-clickaway",
              value: _vm.closeWindow,
              expression: "closeWindow"
            }
          ],
          staticClass: "user-container-div",
          attrs: { id: "badge" }
        },
        [
          _c("div", { attrs: { id: "navbar-vertical-hr" } }),
          _vm._v(" "),
          _c(
            "v-badge",
            {
              staticClass: "ma-4",
              attrs: {
                content: _vm.messages.length > 9 ? "9+" : _vm.messages.length,
                value: _vm.messages.length,
                color: "accent",
                tile: "",
                bordered: "",
                dark: "",
                overlap: ""
              }
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: { click: _vm.onNotificationButtonClick }
                },
                [
                  _c("v-icon", { attrs: { color: "#767676", size: "25" } }, [
                    _vm._v("notifications_none")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("user-button", {
            staticClass: "navbar-user-button",
            attrs: {
              avatarWidth: "35px",
              avatarHeight: "35px",
              nameSize: "12px",
              id: "userButton"
            },
            nativeOn: {
              click: function($event) {
                return _vm.onUserButtonClick.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              _c("notifications-window", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.notificationWindow,
                    expression: "notificationWindow"
                  }
                ],
                attrs: {
                  right: _vm.width,
                  top: "28px",
                  notificationOpen: _vm.notificationWindow
                },
                on: { notifications: _vm.setNotificationNumber }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("user-window", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.userWindow,
                expression: "userWindow"
              }
            ],
            attrs: { right: "15px", top: "55px" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("activate-two-authentication-dialog", {
        attrs: { open: _vm.opened2FArequired },
        on: {
          close: function($event) {
            _vm.opened2FArequired = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fe5b95c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fe5b95c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/NavBar.vue
// module id = null
// module chunks = 